import React from 'react';
import { createRoot } from 'react-dom/client';
import RetargetEvents from 'react-shadow-dom-retarget-events';
import FormExpo from './FormExpo.jsx';
import StyleSheet from 'bundle-text:./styles.css'

export default class FormExpoWrapper extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  connectedCallback() {
    const styleElement = document.createElement('style');
    styleElement.textContent = StyleSheet;
    this.mountPoint = document.createElement('div');
    this.mountPoint.className = 'wrapper-form-expo';
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(styleElement);
    shadowRoot.appendChild(this.mountPoint);

    const createForm = () => React.createElement(
      FormExpo,
      {},
      React.createElement('slot'),
    );

    const root = createRoot(this.mountPoint);
    root.render(createForm());
    RetargetEvents(shadowRoot);
  }
}

window.customElements.define('web-form-expo', FormExpoWrapper);
